import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage, GLMOAuthState } from 'types';
import { client } from 'utils/api-client';

const createGLMOAuthState = (): Promise<AxiosResponse<GLMOAuthState>> => {
  return client.post('/auth/glm-oauth-state/');
};

/**
 * Issues the single-use `state` for the Gym Lead Machine OAuth redirect.
 */
export default function useCreateGLMOAuthState(): UseMutationResult<
  AxiosResponse<GLMOAuthState>,
  AxiosError<ErrorMessage>,
  void
> {
  return useMutation(createGLMOAuthState);
}
